import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchOrderHubOrderDocuments } from '@/api/order-hub';
import { ordersHubKeys } from './useOrdersHubList';

export interface OrderHubAttachmentsParams {
  page: number;
  count: number;
}

function buildQs(orderId: string, params: OrderHubAttachmentsParams): string {
  const qs = new URLSearchParams();
  qs.set('orderId', orderId);
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(Math.min(100, params.count)));
  return qs.toString();
}

export function orderHubAttachmentsQueryOptions(
  orderId: string,
  params: OrderHubAttachmentsParams,
) {
  return queryOptions({
    queryKey: ordersHubKeys.attachments(orderId, params),
    queryFn: () => fetchOrderHubOrderDocuments(buildQs(orderId, params)),
    staleTime: 30_000,
  });
}

export function useOrderHubAttachments(
  orderId: string,
  params: OrderHubAttachmentsParams,
) {
  return useQuery(orderHubAttachmentsQueryOptions(orderId, params));
}
